export default __webpack_public_path__ + "static/logo.stadtmuseumhall-b75c09441402ef1ddaf2f20461a0bb53.jpeg";